import { UserInfo } from './user-info.interface';
import { OrgInfo } from './org-info.interface';
import { SharedOrganization } from './shared-organization.interface';

export const AUTH_STATE_NAME = 'auth';

export interface AuthState {
  userInfo: UserInfo;
  orgInfo: OrgInfo;
  token: string;
  refreshToken: string;
  loginProcess: boolean;
  error: string;
  permissions: string[];
  sharedOrganizations: SharedOrganization[];
  hasInit2FA: {
    secret: string;
    qr: string;
  };
  hasVerify2FA: boolean;
  loadingOtpInitData: boolean;
  loadingUpdateProfileData: boolean;
  disabling2FA: boolean;
}
